import { ChangeDetectorRef, Directive, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { AuthService } from '../root/auth.service';

@Directive({
  selector: '[lohiPayMerchant]',
})
export class PayMerchantDirective implements OnDestroy {
  private destroy$$ = new Subject();
  private hasView = false;

  constructor(
    private authService: AuthService,
    private cd: ChangeDetectorRef,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
    this.setup();
  }

  public ngOnDestroy() {
    this.destroy$$.next();
    this.destroy$$.unsubscribe();
  }

  private setup() {
    this.authService.userInfo$
      .pipe(
        takeUntil(this.destroy$$),
        map((info) => info?.isLoHiPayMerchant ?? false),
      )
      .subscribe({
        next: (isMerchant) => {
          if (isMerchant) {
            if (!this.hasView) {
              this.viewContainer.createEmbeddedView(this.templateRef);
              this.hasView = true;
              this.cd.markForCheck();
            }
          } else {
            if (this.hasView) {
              this.viewContainer.clear();
              this.hasView = false;
              this.cd.markForCheck();
            }
          }
        },
      });
  }
}
